module.exports = __webpack_public_path__ + "media/src/images/icon__magazinFalsch3-c91613f5e60ca3797b970283e0e78c23.svg";